import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=3572cdf2"
import script from "./DetailOrder.vue?vue&type=script&lang=js"
export * from "./DetailOrder.vue?vue&type=script&lang=js"
import style0 from "./DetailOrder.vue?vue&type=style&index=0&id=3572cdf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports